import { Component, NgZone, OnInit, TemplateRef, ViewChild } from '@angular/core';
import { Location } from '@angular/common';
import { ActivatedRoute } from '@angular/router';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ToastrService } from 'ngx-toastr';
import { MenuService } from './services/menu/menu.service';
import { ClienteService } from 'src/app/shared/services/cliente/cliente.service';
import { Module } from './services/menu/responses/menu.response';
import { NextConfig } from '../../../app-config';

@Component({
  selector: 'app-admin',
  templateUrl: './admin.component.html',
  styleUrls: ['./admin.component.scss'],
})
export class AdminComponent implements OnInit {
  @ViewChild('changePasswordModal') changePasswordModal: TemplateRef<any>;

  public nextConfig: any;
  public windowWidth: number;
  externo: boolean;
  modules: Module[] = [];
  newPassword: string;
  confirmPassword: string;
  isPasswordValid: boolean = true;
  isConfirmPasswordValid: boolean = true;
  newPasswordVisible: boolean = false;
  confirmPasswordVisible: boolean = false;
  user = JSON.parse(JSON.parse(localStorage.getItem('AdminImplementos.usuario')));

  constructor(
    private zone: NgZone,
    private location: Location,
    private menuService: MenuService,
    public route: ActivatedRoute,
    private clienteService: ClienteService,
    private modalService: NgbModal,
    private toastr: ToastrService
  ) {
    this.route.data.subscribe((data) => (this.externo = data['externo']));

    this.nextConfig = NextConfig.config;
    let currentURL = this.location.path();
    const baseHerf = this.location['_baseHref'];
    if (baseHerf) {
      currentURL = baseHerf + this.location.path();
    }

    this.windowWidth = window.innerWidth;

    if (
      (currentURL === baseHerf + '/layout/collapse-menu' ||
        currentURL === baseHerf + '/layout/box') &&
      this.windowWidth >= 992 &&
      this.windowWidth <= 1024
    ) {
      this.nextConfig.collapseMenu = true;
    }
  }

  ngOnInit() {
    this.menuService.menu().subscribe((r) => (this.modules = r.data.filter((m) => m.id.toUpperCase() === 'CMS')));
    if (this.windowWidth < 992) {
      this.nextConfig.layout = 'vertical';
      setTimeout(() => {}, 500);
    }
  }
}
